/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ul.pagination[_ngcontent-%COMP%]{margin:0}.seal[_ngcontent-%COMP%]{text-align:center;margin:50px 0 20px}.seal[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]{text-align:center;color:#6495ed;margin-top:50px}\n/*# sourceMappingURL=geodestino-section.component.css.map*/"];
export { styles as styles };
